import CampaignIcon from '@mui/icons-material/Campaign';
import { SidebarItem } from '@traton/devportal-env-kit-app';
import { useAnnouncementPermissions } from '../../hooks/useAnnouncementPermissions';

export const AnnouncementSidebarItem = () => {
  const { canCreate, loading } = useAnnouncementPermissions();

  if (loading || !canCreate) return null;

  return (
    <SidebarItem
      icon={CampaignIcon}
      to="/announcement"
      text="Announcement"
      pluginId="announcement"
    />
  );
};
